<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="850"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Regenerate</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
        <div class="row">
          <div class="min-h-75px col-12 my-0 py-0">
            <v-select
              v-model="formData.type"
              :items="[
                { text: 'Yes', index: 1 },
                { text: 'No', index: 0 },
              ]"
              item-text="text"
              item-value="index"
              label="New data"
              dense
              outlined
              clearable
            />
          </div>

          <div class="min-h-75px col-sm-6 col-12 my-0 py-0">
            <v-menu
              v-model="start_date_menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formData.start_date"
                  label="Start date"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  :error-messages="start_dateErrors"
                  @input="$v.formData.start_date.$touch()"
                  @blur="$v.formData.start_date.$touch()"
                />
              </template>
              <v-date-picker
                v-model="formData.start_date"
                @input="start_date_menu = false"
              />
            </v-menu>
          </div>
          <div class="min-h-75px col-sm-6 col-12 my-0 py-0">
            <v-menu
              v-model="end_date_menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formData.end_date"
                  label="End date"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  :error-messages="end_dateErrors"
                  @input="$v.formData.end_date.$touch()"
                  @blur="$v.formData.end_date.$touch()"
                />
              </template>
              <v-date-picker
                v-model="formData.end_date"
                @input="end_date_menu = false"
              />
            </v-menu>
          </div>
        </div>

        <!--begin::Actions-->
        <div
          class="my-4 min-h-75px d-flex flex-grow-1 align-end justify-center"
        >
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetFormData"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitForm"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

export default {
  name: "Regenerate",
  props: ["updateTableContent", "pageLoader"],
  components: {},
  mixins: [validationMixin],
  validations: {
    formData: {
      start_date: { required },
      end_date: { required },
    },
  },
  data: () => ({
    dialog: false,
    date: { startDate: null, endDate: null },
    inputValue: null,
    menu2: false,
    start_date_menu: false,
    end_date_menu: false,
    formData: {
      type: null,
      start_date: null,
    },
  }),
  methods: {
    getDateRange(val) {
      this.formData.date_range = val;
    },
    toggleModal() {
      this.resetFormData();
      // else {
      //   this.loadDataFromServer();
      // }
      this.dialog = !this.dialog;
    },
    handleFormValidation(fieldName) {
      const errors = [];
      if (!this.$v.formData[fieldName].$dirty) return errors;
      if ("required" in this.$v.formData[fieldName]) {
        !this.$v.formData[fieldName].required &&
          errors.push("This field is required");
      }
      return errors;
    },
    submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.pageLoader(true);
      ApiService.post(`/cod/storage_daily_statistics/regenerate_statistics`, {
        ...this.formData,
      })
        .then(({ data }) => {
          Swal.fire("Success!", data.message, "success");
          this.toggleModal();
          this.updateTableContent();
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    resetFormData() {
      this.formData = { type: null, start_date: null, end_date: null };
    },
  },
  computed: {
    start_dateErrors: function () {
      return this.handleFormValidation("start_date");
    },
    end_dateErrors: function () {
      return this.handleFormValidation("end_date");
    },
  },
};
</script>

<style>
.v-radio label {
  margin-bottom: 0;
}
</style>
